<template>
  <div class="claculator">
    <v-row class="input" justify="center">
      <v-col class="area">
        <v-row>
          <v-col cols="12" lg="4">
            <div class="input-col">
              <div class="header">
                <h1><img class="symbol" src="@/assets/Haushalt-top.png">Haushalt</h1>
              </div>
              <range-input v-model="stromverbrauchHaushalt" :min="1000" :max="10000" :step="100" unit="KWh">
                <template slot="label">Stromverbauch im Jahr:</template>
              </range-input>
              <v-divider class="mt-4 mb-3"></v-divider>
              <label class="mb-0">Stromtyp:</label>
              <v-radio-group class="my-1 py-0" v-model="stromart" row>
                <v-radio value="normal" label="Normaler-Strom" color="#F5A808"/>
                <v-radio value="oeko" label="Öko-Strom" color="#F5A808"/>
              </v-radio-group>
              <range-input v-model="strompreis" :min="0.25" :max="0.5" :step="0.01" unit="€" fixed>
                <template slot="label">Kosten Strom pro KWh in €:</template>
              </range-input>
            </div>
          </v-col>
          <v-col cols="12" lg="4">
            <div class="input-col">
              <div class="header">
                <h1><img class="symbol" src="@/assets/Fahrzeuge-top.png" alt="Fahrzeuge">Fahrzeuge</h1>
              </div>
              <range-input v-model="pkwKillometerJahr" :min="2000" :max="50000"  :step="1000" unit="km">
                <template slot="label">Gefahrene km/ Jahr:</template>
              </range-input>
              <v-divider class="mt-4 mb-3"></v-divider>
              <range-input v-model="pkwVerbrauchKraftstoff" :min="3" :max="25"  unit="l">
                <template slot="label">Verbrauch <span class="font-weight-black">Verbrenner</span> Liter/100 km:</template>
              </range-input>
              <v-radio-group  class="mt-0" v-model="pkwKraftstoffart" row>
                <v-radio value="benzin" label="Benzin" color="#F5A808"/>
                <v-radio value="diesel" label="Diesel" color="#F5A808"/>
              </v-radio-group>
              <range-input v-model="pkwKraftstoffpreis" :min="0.8" :max="2.0"  :step="0.01" unit="€" fixed>
                <template slot="label">Kosten Kraftstoff/ Liter in €:</template>
              </range-input>
              <div  class="elektro-verbrauch">
                <range-input v-model="pkwVerbrauchStrom" :min="10" :max="30"  unit="KWh">
                  <template slot="label"> Verbrauch <span class="font-weight-black">Elektro</span> KWh/100 km:</template>
                </range-input>
              </div>
            </div>
          </v-col>
          <v-col cols="12" lg="4">
            <div class="input-col">
              <div class="header">
                <h1><img class="symbol" src="@/assets/PV-Anlage-top.png">PV-Anlage</h1>
              </div>
              <range-input v-model="stromSpeicher" :min="4" :max="10" unit="KWp">
                <template slot="label">Größe der Anlage:</template>
              </range-input>
              <range-input v-model="autarkie"  :min="40" :max="90" unit="%">
                <template slot="label">Autarkie:</template>
              </range-input>
              <range-input v-model="einspeiseverguetung" :min="0.0" :max="0.2" :step="0.01" unit="€" fixed>
                <template slot="label">Einspeisvergütung pro KWh in €: </template>
              </range-input>
            </div>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
    <v-row class="result" justify="center">
      <v-col class="area">
        <div  class="px-2 py-2">
          <div class="header">
            <h1>Ergebnis – Vergleich Kosten und Emissionen im Jahr</h1>
          </div>
          <v-row no-gutters>
            <v-col cols="12" sm="3">
              <div>Ohne PV / mit Verbrenner</div>
              <img class="symbol" src="@/assets/ohne-PV.png" alt="ohne PV-Anlage">
              <img class="symbol ml-14" src=@/assets/Fahrzeuge.png alt="Verbrenner">
            </v-col>
            <v-col cols="12" sm="9">
              <bar-chart :kosten="gesamtkosten" :emission="gesammtC02" :max="maxDiagram" />
            </v-col>
            <v-col class="mt-3 mt-sm-0" cols="12" sm="3">
              <div>Mit PV / mit Verbrenner</div>
              <img class="symbol" src="@/assets/mit-PV.png" alt="mit PV-Analge">
              <img class="symbol ml-16" src="@/assets/Fahrzeuge.png" alt="Verbrenner">
            </v-col>
            <v-col cols="12" sm="9">
              <bar-chart :kosten="gesamtBetragPVV" :emission="gesamtCO2PVV" :max="maxDiagram"/>
            </v-col>
            <v-col class="mt-3 mt-sm-0" cols="12" sm="3">
              <div>Mit PV / mit Elektro</div>
              <img class="symbol" src=@/assets/mit-PV.png alt="mit PV-Anlage">
              <img  class="symbol ml-16" src=@/assets/mit-Elektro.png alt="Elektrofahrzeug">
            </v-col>
            <v-col cols="12" sm="9">
              <bar-chart :kosten="gesamtBetragPVE" :emission="gesamtCO2StromPVE" :max="maxDiagram"/>
            </v-col>
          </v-row>
        </div>
      </v-col>
    </v-row>
    <v-row class="details d-none d-md-flex" justify="center">
      <v-col class="area">
        <v-expansion-panels>
          <v-expansion-panel>
            <v-expansion-panel-header>
              Details
            </v-expansion-panel-header>
            <v-expansion-panel-content>
              <table class="details">
                <tr>
                  <td></td>
                  <td></td>
                  <td class="font-weight-black haushalt-1 text-center">ohne PV<br>mit Verbrenner</td>
                  <td class="font-weight-black haushalt-2 text-center">mit PV<br>mit Verbrenner</td>
                  <td class="font-weight-black haushalt-3 text-center">mit PV<br>mit Elektro</td>
                </tr>
                <tr>
                  <td class="font-weight-black text-h6">Verbräuche</td>
                  <td class="font-weight-black"></td>
                  <td class="font-weight-black"></td>
                  <td class="font-weight-black"></td>
                  <td class="font-weight-black"></td>
                </tr>
                <tr>
                  <td>Strom Haushalt</td>
                  <td></td>
                  <td>{{ stromverbrauchHaushalt }} kWh</td>
                  <td>{{ stromverbrauchHaushalt }} kWh</td>
                  <td>{{ stromverbrauchHaushalt }} kWh</td>
                </tr>
                <tr>
                  <td>Strom Fahrzeug</td>
                  <td></td>
                  <td>-</td>
                  <td>-</td>
                  <td>{{ jahresVerbrauchElektrofahrzeug }}  kWh</td>
                </tr>
                <tr>
                  <td>Kraftstoff Fahrzeug</td>
                  <td></td>
                  <td>{{ jahresVerbrauchVerbrenner }} l</td>
                  <td>{{ jahresVerbrauchVerbrenner }} l</td>
                  <td>-</td>
                </tr>
                <tr class="gap">
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                </tr>
                <tr>
                  <td class="font-weight-black" colspan="5">Herkunft Energie / Deckung Energiebedarf über</td>
                </tr>
                <tr>
                  <td>Haus-Strom - Über PV-Anlage selbst erzeugt (= Autarkie)</td>
                  <td></td>
                  <td>-</td>
                  <td>{{ stromproduktionHaushalt }} kWh</td>
                  <td>{{ stromproduktionHaushalt }} kWh</td>
                </tr>
                <tr>
                  <td>KFZ-Strom - Über PV-Anlage selbst erzeugt (= Autarkie *0,5)</td>
                  <td></td>
                  <td>-</td>
                  <td>-</td>
                  <td>{{ stromproduktionElektroAuto }} kWh</td>
                </tr>

                <tr>
                  <td>Strom - Von Energieversorger bezogen</td>
                  <td></td>
                  <td>{{ Math.round(stromverbrauchHaushalt) }} kWh</td>
                  <td>{{ Math.round(stromverbrauchHaushalt - stromproduktionHaushalt) }} kWh</td>
                  <td>{{ Math.round(stromverbrauchMitElektroauto - stromproduktionMitElektroauto) }} kWh</td>
                </tr>
                <tr>
                  <td>Tankstelle</td>
                  <td></td>
                  <td>{{ jahresVerbrauchVerbrenner }} l</td>
                  <td>{{ jahresVerbrauchVerbrenner }} l</td>
                  <td>-</td>
                </tr>
                <tr class="gap">
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                </tr>
                <tr>
                  <td class="font-weight-black" colspan="5">Gesamt-Kosten Energie</td>
                </tr>
                <tr>
                  <td>Energieversorger</td>
                  <td></td>
                  <td>{{ bruttoStromkosten.multiply(stromverbrauchHaushalt).format() }}</td>
                  <td>{{ bruttoStromkosten.multiply(stromverbrauchHaushalt - stromproduktionHaushalt).format() }}</td>
                  <td>{{ bruttoStromkosten.multiply(stromverbrauchMitElektroauto - stromproduktionMitElektroauto).format() }}</td>

                </tr>
                <tr>
                  <td>Tankstelle</td>
                  <td></td>
                  <td>{{ jahreskostenTankstelle.format() }}</td>
                  <td>{{ jahreskostenTankstelle.format() }}</td>
                  <td>-</td>
                </tr>
                <tr>
                  <td class="font-weight-black text-decoration-underline">Gesamt</td>
                  <td class="font-weight-black text-decoration-underline"></td>
                  <td class="font-weight-black text-decoration-underline"><span class="text-highlight">{{ gesamtkosten.format() }}</span></td>
                  <td class="font-weight-black text-decoration-underline"><span class="text-highlight">{{ gesamtkostenPVV.format() }}</span></td>
                  <td class="font-weight-black text-decoration-underline"><span class="text-highlight">{{ gesamtkostenPVE.format() }}</span></td>
                </tr>
                <tr class="gap">
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                </tr>
                <tr>
                  <td class="font-weight-black text-h6" colspan="5">Vergütung Einspeisung nicht verbrauchter PV-Strom</td>
                </tr>
                <tr>
                  <td>Einspeisung = Rückvergütung vom Netzbetreiber</td>
                  <td></td>
                  <td>-</td>
                  <td>{{ Math.round(einspeisungOhneElektorauto) }} kWh</td>
                  <td>{{ Math.round(einspeisungMitElektorauto) }} kWh</td>
                </tr>
                <tr>
                  <td class="font-weight-black">Wert Einspeisung ca.</td>
                  <td class="font-weight-black"></td>
                  <td class="font-weight-black">-</td>
                  <td class="font-weight-black">{{ einspeiseverguetungOhneElektorauto.format() }}</td>
                  <td class="font-weight-black">{{ einspeiseverguetungMitElektorauto.format() }}</td>
                </tr>
                <tr>
                  <td class="font-weight-black text-decoration-underline">Gesamtbetrag (Kosten 1 abzgl. Einspeisevergütung)</td>
                  <td></td>
                  <td class="font-weight-black text-decoration-underline "><span class="text-highlight">{{ gesamtkosten.format() }}</span></td>
                  <td class="font-weight-black text-decoration-underline"><span class="text-highlight">{{ gesamtBetragPVV.format() }}</span></td>
                  <td class="font-weight-black text-decoration-underline"><span class="text-highlight">{{ gesamtBetragPVE.format() }}</span></td>
                </tr>
                <tr>
                  <td class="font-weight-black">Jährlicher "ROI" bezogen auf Haushalt 1</td>
                  <td></td>
                  <td></td>
                  <td>{{ roiHaushalt2.format() }}</td>
                  <td>{{ roiHaushalt3.format() }}</td>
                </tr>
                <tr>
                  <td>Verzinsung bei {{ investitionsSumme.format() }} Investition</td>
                  <td></td>
                  <td></td>
                  <td>{{ verzinsungHaushalt2 }}%</td>
                  <td>{{ verzinsungHaushalt3 }}%</td>
                </tr>
                <tr>
                  <td class="font-weight-black">Jährlicher "ROI" bezogen auf Haushalt 2</td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td>{{ gesamtkostenPVV.subtract(einspeiseverguetungOhneElektorauto).subtract(gesamtkostenPVE.subtract (einspeiseverguetungMitElektorauto)).format()  }}</td>
                </tr>
                <tr class="gap">
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                </tr>
                <tr>
                  <td class="font-weight-black text-h6" colspan="5">Umweltschutz: Berechnung CO2-Produktion bzw. Einsparung</td>
                </tr>
                <tr>
                  <td>Stromeinkauf ({{this.stromart}})</td>
                  <td></td>
                  <td>{{Math.round(gesamtCO2Strom)}} kg</td>
                  <td>{{Math.round(gesamtCO2StromPVV)}} kg</td>
                  <td>{{Math.round(gesamtCO2StromPVE)}} kg</td>
                </tr>
                <tr>
                  <td>Kraftstoffeinkauf ({{ this.pkwKraftstoffart }})</td>
                  <td></td>
                  <td>{{ Math.round(gesamtCO2Kraftstoff)}} kg</td>
                  <td>{{ Math.round(gesamtCO2Kraftstoff)}} kg</td>
                  <td>-</td>
                </tr>

                <tr>
                  <td class="font-weight-black text-decoration-underline">Summe CO2-Entstehung für Energiebedarf</td>
                  <td></td>
                  <td class="font-weight-black text-decoration-underline"><span class="text-highlight">{{ Math.round(gesammtC02) }} kg</span></td>
                  <td class="font-weight-black text-decoration-underline"><span class="text-highlight">{{ Math.round(gesamtCO2PVV) }} kg</span></td>
                  <td class="font-weight-black text-decoration-underline"><span class="text-highlight">{{Math.round(gesamtCO2StromPVE) }} kg</span></td>
                </tr>
                <tr>
                  <td class="font-weight-black">Einsparungsmöglichkeiten absolut</td>
                  <td></td>
                  <td></td>
                  <td class="font-weight-black">{{ Math.round(gesammtC02 - gesamtCO2PVV) }} kg</td>
                  <td class="font-weight-black">{{ Math.round(gesammtC02 - gesamtCO2StromPVE) }} kg</td>
                </tr>
                <tr>
                  <td class="font-weight-black">Einsparungsmöglichkeiten relativ</td>
                  <td></td>
                  <td></td>
                  <td class="font-weight-black">{{  Math.round(( gesammtC02 - gesamtCO2PVV ) / gesammtC02  * 100) }}%</td>
                  <td class="font-weight-black">{{  Math.round(( gesammtC02 - gesamtCO2StromPVE) / gesammtC02  * 100) }}%</td>
                </tr>
              </table>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import currency from 'currency.js';
import RangeInput from "@/components/RangeInput";
import BarChart from "@/components/BarChart";
const EURO = value => currency(value, { symbol: '€', decimal: ',', separator: '.', pattern: '# !' });
export default {
  name: "calculator.vue",
  components: { BarChart, RangeInput },
  data() {
    return {
      mehrwertsteuer: 16,
      strompreis: 0.29,
      einspeiseverguetung: 0.10,
      stromart: 'normal',
      stromverbrauchHaushalt: 4500,
      pkwKraftstoffart: 'benzin',
      pkwKraftstoffpreis: 1.10,
      pkwKillometerJahr: 15000,
      pkwVerbrauchKraftstoff: 7,
      pkwVerbrauchStrom: 16,
      stromSpeicher: 7,
      autarkie: 58
    }
  },
  methods: {
    verzinsung(kosten) {
      return kosten / this.investitionsSumme * 100
    }
  },
  computed: {
    bruttoStromkosten() {
      return EURO(this.strompreis);
    },
    bruttoEinspeiseverguetung() {
      return EURO(this.einspeiseverguetung);
    },
    jahresVerbrauchVerbrenner() {
      return this.pkwKillometerJahr / 100 * this.pkwVerbrauchKraftstoff
    },
    jahresVerbrauchElektrofahrzeug() {
      return this.pkwKillometerJahr / 100 * this.pkwVerbrauchStrom
    },
    stromverbrauchMitElektroauto() {
      return parseFloat(this.stromverbrauchHaushalt ) + parseFloat(this.jahresVerbrauchElektrofahrzeug)
    },
    produktionJahrKW() {
      return this.stromSpeicher * 1000
    },
    stromproduktionHaushalt() {
      return this.stromverbrauchHaushalt * this.autarkie / 100
    },
    stromproduktionMitElektroauto() {
      return this.stromproduktionHaushalt + this.stromproduktionElektroAuto
    },
    stromproduktionElektroAuto() {
      return parseFloat(this.jahresVerbrauchElektrofahrzeug) * this.autarkie * 0.5 / 100
    },
    maximalSelbstNutzbarerStrom() {
      return this.autarkie / 100 * this.produktionJahrKW
    },
    jahreskostenTankstelle() {
      return EURO(this.pkwKraftstoffpreis).multiply(this.jahresVerbrauchVerbrenner)
    },
    einspeisungMitElektorauto() {
      return this.stromSpeicher * 1000 - this.stromproduktionMitElektroauto
    },
    einspeisungOhneElektorauto() {
      return this.stromSpeicher * 1000 - this.stromproduktionHaushalt
    },
    einspeiseverguetungOhneElektorauto() {
      return this.bruttoEinspeiseverguetung.multiply(this.einspeisungOhneElektorauto)
    },
    einspeiseverguetungMitElektorauto() {
      return this.bruttoEinspeiseverguetung.multiply(this.einspeisungMitElektorauto)
    },
    gesamtkosten() {
      return this.bruttoStromkosten.multiply(this.stromverbrauchHaushalt).add(this.jahreskostenTankstelle)
    },
    gesamtkostenPVV() {
      return this.bruttoStromkosten.multiply(this.stromverbrauchHaushalt - this.stromproduktionHaushalt).add(this.jahreskostenTankstelle)
    },
    gesamtkostenPVE() {
      return this.bruttoStromkosten.multiply(this.stromverbrauchMitElektroauto - this.stromproduktionMitElektroauto)
    },
    gesamtBetragPVV() {
      return this.gesamtkostenPVV.subtract(this.einspeiseverguetungOhneElektorauto)
    },
    gesamtBetragPVE() {
      return this.gesamtkostenPVE.subtract(this.einspeiseverguetungMitElektorauto)
    },
    gesamtCO2Strom() {
      return this.stromverbrauchHaushalt * this.co2proKKW
    },
    gesamtCO2StromPVV() {
      return (this.stromverbrauchHaushalt - this.stromproduktionHaushalt) * this.co2proKKW
    },
    gesamtCO2StromPVE() {
      return (this.stromverbrauchMitElektroauto - this.stromproduktionMitElektroauto) * this.co2proKKW
    },
    gesamtCO2Kraftstoff() {
      return this.jahresVerbrauchVerbrenner * this.co2proLiter
    },
    co2proLiter() {
      return this.pkwKraftstoffart === 'benzin' ? 2.32 : 2.63
    },
    co2proKKW() {
      return this.stromart === 'normal' ? 0.49 : 0.04
    },
    gesammtC02() {
      return this.gesamtCO2Strom + Math.ceil(this.gesamtCO2Kraftstoff)
    },
    gesamtCO2PVV() {
      return this.gesamtCO2StromPVV + Math.ceil(this.gesamtCO2Kraftstoff)
    },
    roiHaushalt2() {
      return this.gesamtkosten.subtract(this.gesamtkostenPVV.subtract(this.einspeiseverguetungOhneElektorauto))
    },
    roiHaushalt3() {
      return this.gesamtkosten.subtract(this.gesamtkostenPVE.subtract(this.einspeiseverguetungMitElektorauto))
    },
    verzinsungHaushalt2() {
      return this.verzinsung(this.roiHaushalt2).toFixed(2)
    },
    verzinsungHaushalt3() {
      return  this.verzinsung(this.roiHaushalt3).toFixed(2)
    },
    investitionsSumme() {
      return EURO(this.stromSpeicher * 2000)
    },
    maxDiagram() {

      let maxRange = Math.max(
          this.gesamtkosten, this.gesammtC02,
          this.gesamtkostenPVV, this.gesamtCO2PVV,
          this.gesamtkostenPVE,  this.gesamtCO2StromPVE
      )
      return maxRange < 7000 ? 7000 : maxRange

    }
  }
}
</script>

<style lang="scss" scoped>


.area {
  max-width: 1144px;
}
.input {
  .input-col {
    margin-left: 5.76%;
    margin-right: 5.76%;
    padding-left: 0 !important;
    padding-right: 0 !important;
  }
}

.header {
  h1 {
    color: #0b2b3a;
    font-family: "Open Sans", Arial, Helvetica, sans-serif;
    font-size: 20px;
    font-weight: 800;
    line-height: 1.2;
    letter-spacing: 0;
    font-style: normal;
    margin-top:0;
    margin-bottom: 15px;
  }
  .symbol {
    margin-right: 10px;
  }
}
.symbol {
  vertical-align: baseline;
  height: 45px;
  width: auto;
}

.v-input {
  ::v-deep .v-messages {
    min-height: 0;
  }
}

label {
  display: block;
}
.result {
  background-color: rgb(237, 236, 235);
}

.details {
  border-collapse: collapse;
  table {
    border: none;

    tr {
      &:nth-child(2n+3) {
        background-color: #f2f2f2;;
      }
      &:nth-child(2) {
        > td:nth-child(3) {
          background: url("../assets/Haushalt.png") right 60px center no-repeat, url("../assets/Fahrzeuge.png") right center no-repeat;
          background-size: 40px;
          height: 50px;
          padding: 0 30px;
          font-size: 0;
        }

        > td:nth-child(4) {
          background: url("../assets/mit-PV.png") right 60px center no-repeat, url("../assets/Fahrzeuge.png") right center no-repeat;
          background-size: 40px;
          height: 50px;
          padding: 0 30px;
          font-size: 0;
        }
        > td:nth-child(5) {
          background: url("../assets/mit-PV.png") right 60px center no-repeat, url("../assets/mit-Elektro.png") right center no-repeat;
          background-size: 40px;
          height: 50px;
          padding: 0 30px;
          font-size: 0;
        }
      }
      &.gap td {
        background-color: white;
        height: 40px;
        &::after {
          content: "\00a0";
        }
      }
    }
    td {
      &:first-child {
        width: 550px;
        text-align: left;
      }
      padding: 3px;
      width: 200px;
      text-align: right;
      &.haushalt-1 {
        background-color: #d9d9d9;
      }
      &.haushalt-2 {
        background-color: #e2f0d9;
      }
      &.haushalt-3 {
        background-color: #92d050;
      }
    }
  }
}
.elektro-verbrauch {
  margin-top: 10px;
}
.text-highlight {
  background-color: #EC8F1C;
  padding: 4px 0 4px 4px;
}
.text-h6 {
  color: #EC8F1C;
}
</style>
